import { useEffect, useState } from "react"
import { Box, Card, CardContent, Stack, Typography } from "@mui/material"
import { Area, AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import useFetch from "../api/api"
import Loading from "./Loading"

import moment from 'moment'
import config from "../common/Config";

const CustomTooltip = ({ active, payload, label }) => {

	const currencyFormat = new Intl.NumberFormat('pt-BR', {
		style : "currency",
		currency : "BRL",
		maximumFractionDigits: 0, 
		minimumFractionDigits: 0, 
	})

	return (
		<Card>
			<CardContent>
				<Stack spacing={1}>
					<Typography align="center" sx={{fontWeight: 'bold'}}>Posição em {new Date(label).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</Typography>
					<Typography align="center" sx={{color: payload[0]?.stroke}}>{currencyFormat.format(payload[0]?.value)}</Typography>
				</Stack>
			</CardContent>
		</Card>
	)
}

const PortfolioHistory = (props) => {
	const [portfolioHistory, setPortfolioHistory] = useState()
	const privateFetch = useFetch()

	useEffect(() => {
		privateFetch(config.apiUrl +'/api/portfolio/history')
		.then(data => data.json())
		.then(data => setPortfolioHistory(data.map(d => ({
			date	: d.date,
			total	: Math.round(d.total)
		}))))
		
	}, [])

	return (
		portfolioHistory?.length > 0 ? 
			<ResponsiveContainer width={'98%'} height={props.height ? props.height : 400}>
				<AreaChart 
					width={1000}
					height={400}
					data={portfolioHistory}
					margin={{
						top: 50,
						right: 5,
						left: 20,
						bottom: 5,
					}}
					>
					<defs>
						<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
							<stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
						</linearGradient>
					</defs>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="date" tickFormatter={(item) => moment(item).format('D/MM/YYYY')} style={{fontSize: 10}}/>
					<YAxis 
						yAxisId="left" 
						tickFormatter={(item) => item.toFixed(0)} 
						style={{fontSize: 10}} 
						domain={[dataMin => dataMin * 0.9, dataMax => dataMax * 1.1]} 
					/>
					<Tooltip content={<CustomTooltip/>} />
					<Legend  style={{fontSize: 12}}/>
					<Area yAxisId="left" connectNulls type="monotone" dataKey="total" dot={false} stroke="#8884d8" fill="url(#colorUv)"/>
				</AreaChart>
			</ResponsiveContainer>
		: portfolioHistory ? <Box height={400}><Typography paddingTop={5} paddingLeft={3}>No history found!</Typography></Box> : <Loading/>
		
	)
}

export default PortfolioHistory